import { LanguageService } from '../language/language.service';
import { OmapiIdConstants } from '../../shared/omapi-id-constants';
import { Environment } from '../../shared/environment/environment';
import { TvshopConstants } from '../../shared/tvshop-constants';
import { BehaviorSubject } from 'rxjs';
import { ImageUtils } from '../../shared/utils/image/image-utils';
import { OmapiIdsUtils } from '../../shared/utils/omapi-ids/omapi-ids-utils';
import { TvShopStateService } from '../state/tv-shop-state.service';
import * as i0 from "@angular/core";
import * as i1 from "../language/language.service";
import * as i2 from "../state/tv-shop-state.service";
var CarouselService = /** @class */ (function () {
    function CarouselService(languageService, stateService) {
        this.languageService = languageService;
        this.stateService = stateService;
        this.highlightedOmapiId = OmapiIdConstants.PLAY_SPORTS;
        this.highlightedImages$ = new BehaviorSubject(undefined);
        this.carouselImages$ = new BehaviorSubject(undefined);
        this.omapiIds = [];
        this.carouselTempImages = [];
    }
    CarouselService.prototype.getMainPack = function (packs) {
        var _this = this;
        var omapiId_BE_TV = OmapiIdConstants.BE_TV_VLA;
        var omapiId_BE_TV_SPORT = OmapiIdConstants.BE_TV_SPORT_VLA;
        if (packs.find(function (pack) { return pack.omapiId === OmapiIdConstants.BE_TV_BXL_WAL; })) {
            omapiId_BE_TV = OmapiIdConstants.BE_TV_BXL_WAL;
            omapiId_BE_TV_SPORT = OmapiIdConstants.BE_TV_SPORT_BXL_WAL;
        }
        if (packs.find(function (pack) { return pack.omapiId === OmapiIdConstants.PLAY_SPORTS; })) {
            this.highlightedOmapiId = OmapiIdConstants.PLAY_SPORTS;
        }
        else {
            this.highlightedOmapiId = omapiId_BE_TV_SPORT;
        }
        if (!this.isPackSubscribed(packs, OmapiIdConstants.PLAY_MORE)) {
            if (this.languageService.getCurrentLanguage() === 'fr') {
                if (this.isPackSubscribed(packs, omapiId_BE_TV)) {
                    this.highlightedOmapiId = omapiId_BE_TV_SPORT;
                }
                else {
                    this.highlightedOmapiId = omapiId_BE_TV;
                }
            }
            else {
                if (this.isPackSubscribed(packs, OmapiIdConstants.STREAMZ)) {
                    this.highlightedOmapiId = OmapiIdConstants.RED_CARPET_MORE;
                }
                else if (this.isPackSubscribed(packs, OmapiIdConstants.RED_CARPET_MORE)) {
                    this.highlightedOmapiId = OmapiIdConstants.PLAY_MORE;
                }
                else if (packs.find(function (pack) { return pack.omapiId === OmapiIdConstants.STREAMZ; })) {
                    this.highlightedOmapiId = OmapiIdConstants.STREAMZ;
                }
            }
        }
        if (!this.highlightedImages$.getValue()) {
            this.createHighlightedBannerInMemory();
        }
        return packs.find(function (pack) { return pack.omapiId === _this.highlightedOmapiId; });
    };
    CarouselService.prototype.getProductsInCarousel = function (packs, mainPack) {
        var _this = this;
        var productInCarousel = [];
        var redCarpetMorePack;
        packs.forEach(function (entertainmentPack) {
            if (!_this.isNotCarouselItem(entertainmentPack, mainPack)) {
                if (OmapiIdConstants.RED_CARPET_MORE === entertainmentPack.omapiId) {
                    redCarpetMorePack = entertainmentPack;
                }
                else {
                    productInCarousel.push(entertainmentPack);
                }
            }
        });
        if (redCarpetMorePack) {
            var index = productInCarousel.findIndex(function (pack) { return pack.omapiId === OmapiIdConstants.STREAMZ; });
            productInCarousel.splice(index + 1, 0, redCarpetMorePack);
        }
        var isEligibleForStreamingBundles = this.stateService.selectSnapshot(function (state) { return state.customer.isEligibleForStreamingBundles; });
        if (isEligibleForStreamingBundles) {
            productInCarousel.push(packs.find(function (pack) { return pack.omapiId === _this.highlightedOmapiId; }));
        }
        return productInCarousel;
    };
    CarouselService.prototype.isNotCarouselItem = function (entertainmentPack, mainPack) {
        return entertainmentPack.omapiId === OmapiIdConstants.VOO_FOOT_VLA ||
            entertainmentPack.omapiId === OmapiIdConstants.VOO_FOOT_BXL_WAL ||
            (mainPack ? entertainmentPack.omapiId === mainPack.omapiId : entertainmentPack.omapiId === this.highlightedOmapiId)
            || (entertainmentPack.isTrial && entertainmentPack.omapiId !== OmapiIdConstants.TRIALS
                && entertainmentPack.omapiId !== OmapiIdConstants.PLAY_SPORTS && entertainmentPack.omapiId !== OmapiIdConstants.RED_CARPET_MORE
                && entertainmentPack.omapiId !== OmapiIdConstants.PLAY_MORE && entertainmentPack.omapiId !== OmapiIdConstants.STREAMZ)
            || entertainmentPack.isDayPass;
    };
    CarouselService.prototype.isPackSubscribed = function (packs, omapiId) {
        var pack = packs.find(function (packT) { return packT.omapiId === omapiId; });
        return pack ? pack.subscribed : false;
    };
    CarouselService.prototype.createHighlightedBannerInMemory = function () {
        var images = [];
        images[this.highlightedOmapiId + '-banner'] = this.createBannerImage();
        images[this.highlightedOmapiId + '-logo'] = this.createBannerLogoImage();
        this.highlightedImages$.next(images);
    };
    CarouselService.prototype.createBannerImage = function () {
        var bannerImage = new Image();
        var baseUrl = Environment.environmentConfig() && Environment.environmentConfig().baseUrl;
        bannerImage.src = baseUrl + TvshopConstants.IMAGES_AEM_PATH + OmapiIdsUtils.getCorrectIdForResource(this.highlightedOmapiId) + '-banner.jpg';
        bannerImage.setAttribute('style', 'width:100%; transition:@transition;display: block;');
        bannerImage.className = 'highlighted-product';
        return bannerImage;
    };
    CarouselService.prototype.createBannerLogoImage = function () {
        var logoImage = new Image();
        logoImage.src = ImageUtils.getLogoUrlForOmapiId(this.highlightedOmapiId);
        logoImage.setAttribute('style', 'margin-bottom:10px;max-width: 23vw;');
        logoImage.className = 'highlighted-product';
        return logoImage;
    };
    CarouselService.prototype.createCarouselImages = function (packs) {
        var _this = this;
        packs.filter(function (pack) { return !_this.isNotCarouselItem(pack); }).forEach(function (pack) { return _this.omapiIds.push(pack.omapiId); });
        this.omapiIds.forEach(function (omapiId) {
            _this.createInMemoryCarouselImages(omapiId);
        });
        this.carouselImages$.next(this.carouselTempImages);
    };
    CarouselService.prototype.createCarouselImagesForStreamingServices = function (streamingServices) {
        var _this = this;
        streamingServices.forEach(function (service) {
            _this.createInMemoryCarouselImages(service.omapiId);
        });
        this.carouselImages$.next(this.carouselTempImages);
    };
    CarouselService.prototype.createInMemoryCarouselImages = function (omapiId) {
        var baseUrl = Environment.environmentConfig() && Environment.environmentConfig().baseUrl;
        this.carouselTempImages[omapiId + '-item'] = new Image();
        this.carouselTempImages[omapiId + '-item'].src = baseUrl + TvshopConstants.IMAGES_AEM_PATH + OmapiIdsUtils.getCorrectIdForResource(omapiId) + '-item.jpg';
        this.carouselTempImages[omapiId + '-item'].setAttribute('style', 'width:100%; transition:@transition;display: block;height:100%;object-fit: cover;');
        this.carouselTempImages[omapiId + '-item'].className = 'product-item';
    };
    CarouselService.ngInjectableDef = i0.defineInjectable({ factory: function CarouselService_Factory() { return new CarouselService(i0.inject(i1.LanguageService), i0.inject(i2.TvShopStateService)); }, token: CarouselService, providedIn: "root" });
    return CarouselService;
}());
export { CarouselService };
